import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const dynamicallyImportedFailMessage =
      'Failed to fetch dynamically imported module';
    const message = error?.message as string;

    if (
      chunkFailedMessage.test(message) ||
      (message && message.includes(dynamicallyImportedFailMessage))
    ) {
      console.warn(
        'Failed to fetch dynamically imported module error happened and was handled',
      );
      window.location.reload();
      return;
    }

    if (error instanceof Error) {
      console.error('Error occurred:', error.message);
      if (error.stack) {
        console.error('Stack trace:', error.stack);
      }
    } else if (error && typeof error === 'object') {
      console.error('Error occurred:', JSON.stringify(error, null, 2));
    } else {
      console.error('Unexpected error:', error);
    }
  }
}
